import axios, { AxiosRequestConfig } from 'axios';
import { Version, host } from '@/utils/config';
import { Message } from 'element-ui';
import { getUserId } from '@/utils/storage';
import md5 from 'js-md5'
import router from '@/router'
import { removeUserInfo, removeUserId } from '@/utils/storage';
import store from '@/store'


axios.defaults.timeout = 2*60*1000
const service = axios.create({
  baseURL: host,
  timeout: 2*60*1000,
  method: 'post',
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    let userid = Object.prototype.hasOwnProperty.call(config.data, 'user_id')
      ? config.data.user_id
      : getUserId();
      userid = userid || '0'
    if (config.data) {
      config.data.user_id = userid;
    }
    const timestamp = new Date().getTime().toString();
    const n = parseInt((Math.random() * 1000).toString()).toString();
    const s = md5(md5(String(userid)) + '_' + md5(timestamp) + '_' + md5(n));
    config.headers = Object.assign(config.headers, {
      userid: userid,
      version: Version,
      s,
      t: timestamp,
      r: n
    });
    return config;
  },
  (error) => {
    // console.log(error,3)
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    // console.log(JSON.parse(response.config.data))
    const postData = JSON.parse(response.config.data)
    if (response.status === 200){
      const res = response.data;
      if (res.ErrorCode === 0) {
        return res;
      }else if(res.ErrorCode === 1000005){
        store.dispatch('setPsdEasy', true)
        return res
      }else if (res.ErrorCode === 20000004){
        Message({
          message: '无操作权限，请刷新页面',
          type: 'error',
          duration: 3000,
        });
        return res
      }else if(postData.noError){
        return res
      }else if (res.ErrorCode) {
        if (res.Message) {
          Message({
            message: res.Message,
            type: 'error',
            duration: 3000,
          });
        }
        return Promise.reject(res.status);
      }
    }else{
      Message({
        message: '网络错误'+response.status,
        type: 'error',
        duration: 3000,
      });
      // console.log(1)
      return
    }
    
  },
  (error) => {
    if (error.toString().split('Error: Request failed with status code ')[1] == 401){
      removeUserInfo();
      removeUserId();
      router.push({
        name: 'login'
      })
    }else{
      Message({
        message: '网络错误',
        type: 'error',
        duration: 3000,
      });
    }
    // console.log(2)
    return Promise.reject(error);
  }
);

export default service;
